const general = [
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "Amit Kamath",
        "title": "Asian Games 2023 Live Updates: Blue Tigers move on to RO16, Nikhat Zareen wins her bout in boxing round 1, rowers and shooters win medals - The Indian Express",
        "description": "Asian Games 2023 Day 1 Highlights: The women's cricket team assured themselves a spot in the final while Nikhat Zareen and the men's football team moved into the next round of their respective events",
        "url": "https://indianexpress.com/article/sports/sport-others/asian-games-2023-day-1-live-updates-ind-vs-ban-cricket-hockey-nikhat-zareen-boxing-badminton-rowing-shooting-8953208/",
        "urlToImage": "https://images.indianexpress.com/2023/09/Asian-games-Day-1.jpg",
        "publishedAt": "2023-09-24T14:22:00Z",
        "content": "Mihir Vasavda at Asian Games: Sick man of East Asia? From Bruce Lee to Chinese athletes, Hangzhou 2023 to deliver political and sporting answers\r\n Hangzhou 2022 - Opening Ceremony - Hangzhou Olympic … [+963 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "NASA says samples from asteroid Bennu will land on Earth Sunday - FOX 61",
        "description": "➡️Subscribe to FOX61 for exclusive content: https://www.youtube.com/Foxctlive➡️Visit our website: https://www.fox61.com/Follow FOX61 News on social media!➡️F...",
        "url": "https://www.youtube.com/watch?v=wuvtny6ND-4",
        "urlToImage": "https://i.ytimg.com/vi/wuvtny6ND-4/hqdefault.jpg",
        "publishedAt": "2023-09-24T13:03:42Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "Express Web Desk",
        "title": "Bengaluru News Live Updates: PM Modi flags off Bengaluru-Hyderabad Vande Bharat train; farmers’ group call for Bandh in city over Cauvery row on Tuesday - The Indian Express",
        "description": "Karnataka to follow SC order and release Cauvery water to TN till Tuesday.",
        "url": "https://indianexpress.com/article/cities/bangalore/bengaluru-news-live-updates-cauvery-row-water-tamil-nadu-karnataka-vande-bharat-express-pm-modi-weather-8953521/",
        "urlToImage": "https://images.indianexpress.com/2023/09/Untitled-design-21-1.jpg",
        "publishedAt": "2023-09-24T12:44:17Z",
        "content": "The High Court of Karnataka has dismissed a petition filed by Dharwad MLA Vinay Kulkarni seeking relaxation of bail conditions that restrict his entry into the district.\r\nThe Congress MLA is the main… [+508 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Rahul Gandhi predicts certain win for Congress in upcoming Assembly polls | Mint - Mint",
        "description": "Former Congress president Rahul Gandhi said the Congress would win the upcoming Assembly elections in Madhya Pradesh, Chhattisgarh, and Rajasthan and stands a chance in Telangana too",
        "url": "https://www.livemint.com/news/india/rahul-gandhi-predicts-certain-win-for-congress-in-upcoming-assembly-polls-11695558577750.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/Rahul_Gandhi_1695558877992_1695558878281.jpg",
        "publishedAt": "2023-09-24T12:38:27Z",
        "content": "Congress leader Rahul Gandhi Sunday accused the Bharatiya Janata Party of indulging in diversion tactics\" and said the ruling BJP was likely to receive an unexpected outcome in 2024 Lok Sabha electio… [+3503 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "NDTV News"
        },
        "author": null,
        "title": "US Envoy Says Canada Received 'Five Eyes' Intel Against India: Report - NDTV",
        "description": "A top US diplomat has confirmed that there was \"shared intelligence among Five Eyes partners\" that had prompted Canadian PM Justin Trudeau's offensive allegation about Indian agents' involvement in the killing of a Khalistani terrorist in Canada,",
        "url": "https://www.ndtv.com/india-news/khalistani-terrorist-hardeep-singh-nijjar-justin-trudeau-pm-narendra-modi-us-envoy-confirms-canada-received-five-eyes-intel-against-india-report-4416628",
        "urlToImage": "https://c.ndtvimg.com/2023-09/seuhqis_pm-modi-justin-trudeau-ani_625x300_22_September_23.jpg",
        "publishedAt": "2023-09-24T11:44:00Z",
        "content": "India has rejected Justin Trudeau's allegations as \"absurd\" and \"motivated\"\r\nToronto: A top United States diplomat has confirmed that there was \"shared intelligence among Five Eyes partners\" that had… [+4352 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "What exactly is the Five Eyes Alliance Intelligence: PM Trudeau's source for linking India to Nijjar killing - Times of India",
        "description": "In recent revelations, the US ambassador to Canada has disclosed a significant development in international intelligence cooperation. Critical intelligence shared among the Five Eyes alliance played a pivotal role in Canadian Prime Minister Justin Tr",
        "url": "https://timesofindia.indiatimes.com/videos/toi-original/what-exactly-is-the-five-eyes-alliance-intelligence-pm-trudeaus-source-for-linking-india-to-nijjar-killing/videoshow/103908954.cms",
        "urlToImage": "https://timesofindia.indiatimes.com/photo/msid-103908954,imgsize-70880.cms",
        "publishedAt": "2023-09-24T11:40:36Z",
        "content": "Sep 24, 2023, 06:47PM ISTSource: TOI.inIn recent revelations, the US ambassador to Canada has disclosed a significant development in international intelligence cooperation. Critical intelligence shar… [+1172 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "Jaspreet Sahni",
        "title": "Asian Games: Acclimatization, 'desert storm' behind India's medal rush in rowing - IndiaTimes",
        "description": "Asian Games 2023 News: Rowing involves a plethora of technical intricacies, including concepts like tailwind, headwind, stroke rate, oar angles, arc angles, and force applic",
        "url": "https://timesofindia.indiatimes.com/sports/asian-games-2023/india-asian-games/asian-games-acclimatization-desert-storm-behind-indias-medal-rush-in-rowing/articleshow/103908360.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103908447,width-1070,height-580,imgsize-60598,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T11:18:00Z",
        "content": "19th Asian Games: Indian rowers win silver in Men's Coxed Eight eventIndian rowers secured a second-place finish in the Men's Coxed Eight final event at the 19th Asian Games in Hangzhou, marking thei… [+166 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Sports Desk",
        "title": "Gill pips Sachin with 6th ODI hundred; Iyer scores perfectly-timed ton before WC - Hindustan Times",
        "description": "Iyer and Gill tormented the Cummins-less Aussie attack in Indore to smash their respective centuries while stitching a record 200-plus stand | Cricket",
        "url": "https://www.hindustantimes.com/cricket/ind-vs-aus-shubman-gill-equals-ponting-zooms-past-sachin-tendulkar-6th-odi-century-shreyas-iyer-perfectly-timed-ton-wc-101695550067738.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/India-Australia-Cricket-11_1695550297212_1695550326949.jpg",
        "publishedAt": "2023-09-24T11:14:27Z",
        "content": "Two days back, Shreyas Iyer was left visibly frustrated when he found himself at the wrong end of a run-out mix-up in the opening match of the ODI series against Australia in Mohali. Iyer, who has be… [+3659 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Poulomi Ghosh",
        "title": "BSP MP seeks action against Dubey: ‘Verbal lynching inside, now trying outside' - Hindustan Times",
        "description": "BSP MP Danish Ali said he was ‘verbally lynched’ inside the Lok Sabha by Ramesh Bidhuri and now some other BJP MPs (Dubey) are trying to do it outside.  | Latest News India",
        "url": "https://www.hindustantimes.com/india-news/bsp-mp-seeks-action-against-nishikant-dubey-verbal-lynching-inside-now-trying-outside-101695553429392.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/danish_ali_ramesh_bidhuri_1695553678170_1695553685420.jpg",
        "publishedAt": "2023-09-24T11:14:13Z",
        "content": "BSP MP Danish Ali who was abused by BJP MP Ramesh Bidhuri in the Lok Sabha on Friday sought action against Nishikant Dubey for accusing Danish Ali of insulting PM Modi first. If what Nishikant Dubey … [+2338 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "SpaceX launches Starlink batch on record-tying 17th mission, nails landing - VideoFromSpace",
        "description": "A SpaceX Falcon 9 launched 22 Starlink satellites from Cape Canaveral Space Force Station in Florida on Sept. 23, 2023 at 11:38 p.m. EDT (0338 GMT on Sept. 2...",
        "url": "https://www.youtube.com/watch?v=E2LrYC0GaI0",
        "urlToImage": "https://i.ytimg.com/vi/E2LrYC0GaI0/maxresdefault.jpg",
        "publishedAt": "2023-09-24T11:00:13Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "As iphone 15 Goes On Sale, People Queue Up And Wait For Hours Outside 2 Apple Stores In India - India Today",
        "description": "Apple fans queued up in long lines — for the first time outside an Apple Store in India — as the iPhone 15 and the iPhone 15 Pro went on sale on November 22....",
        "url": "https://www.youtube.com/watch?v=RGBrvMuFSQo",
        "urlToImage": "https://i.ytimg.com/vi/RGBrvMuFSQo/maxresdefault.jpg",
        "publishedAt": "2023-09-24T10:32:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Neurologylive.com"
        },
        "author": "Matt Hoffman",
        "title": "NeurologyLive® Brain Games: September 24, 2023 - Neurology Live",
        "description": "Test your neurology knowledge with NeurologyLive®'s weekly quiz series, featuring questions on a variety of clinical and historical neurology topics. This week's topic is headache and migraine.",
        "url": "https://www.neurologylive.com/view/neurologylive-brain-games-september-24-2023",
        "urlToImage": "https://cdn.sanity.io/images/0vv8moc6/neurolive/2accefc3e108ad7aa14a54f1b916b59d81c52548-1251x1251.png?fit=crop&auto=format",
        "publishedAt": "2023-09-24T10:08:07Z",
        "content": "Welcome to NeurologyLive® Brain Games! This weekly quiz series, which goes live every Sunday morning, will feature questions on a variety of clinical and historical neurology topics, written by physi… [+1432 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Jagran.com"
        },
        "author": "Vikas Yadav",
        "title": "Amazon Great Indian Festival Sale 2023 Date LEAKED; Check Offers, Bank Discounts, Smartphone Deals Here - Jagran English",
        "description": "Amazon Great Indian Festival Sale 2023 Start Date Several users posted screenshots of the sale date on microblogging platform X formerly called Twitter For the unversed the e-commerce platform teased the bank offers and additional benefits of the sale on Sept…",
        "url": "https://english.jagran.com/technology/amazon-great-indian-festival-sale-2023-date-leaked-time-offers-bank-discount-smartphone-deals-quiz-10102699",
        "urlToImage": "https://imgeng.jagran.com/images/2023/sep/amazon-great-indian-sale-20231695550173564.jpg",
        "publishedAt": "2023-09-24T10:02:00Z",
        "content": "Amazon Great Indian Sale 2023 Date: Just one day after the announcement of the Amazon Great Indian Festival sale, the date of the highly-anticipated sale has been leaked. Several users posted screens… [+2435 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "NDTV News"
        },
        "author": "NDTV Sports Desk",
        "title": "India vs Australia Live Score, 2nd ODI: Shubman Gill Hits 50, 1-Down India Solid Against Australia - NDTV Sports",
        "description": "India vs Australia Live Score: Shubman Gill and Shreyas Iyer have smashed their respective half-centuries",
        "url": "https://sports.ndtv.com/cricket/ind-vs-aus-live-score-2nd-odi-cricket-match-india-vs-australia-latest-updates-4418669",
        "urlToImage": "https://c.ndtvimg.com/2023-09/77f5si6o_shreyas-iyer-and-shubman-gill-afp_625x300_24_September_23.jpg?im=FitAndFill,algorithm=dnn,width=1200,height=675",
        "publishedAt": "2023-09-24T09:40:05Z",
        "content": "India vs Australia Live Score: Shreyas Iyer and Shubman Gill have smashed their respective half-centuries and have stitched a 150-run partnership. Despite losing the wicket of Ruturaj Gaikwad early i… [+825 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Saurav Mukherjee",
        "title": "RBI likely to maintain status quo on policy rates as inflation still high: Experts | Mint - Mint",
        "description": "On 8 February, 2023, the apex bank raised the benchmark repo rate to 6.5 percent and since then it has retained the rates at the same level",
        "url": "https://www.livemint.com/economy/rbi-likely-to-maintain-status-quo-on-policy-rates-as-inflation-still-high-experts-11695547523319.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/RBI_1695547654305_1695547654424.jpg",
        "publishedAt": "2023-09-24T09:28:54Z",
        "content": "At its bi-monthly monetary policy review meeting early next month, the Reserve Bank may keep the same policy rates for the fourth time in a row as retail inflation continues to remain high and the US… [+3738 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Daijiworld.com"
        },
        "author": null,
        "title": "Study shows our gut microbes may determine bone health - Daijiworld.com",
        "description": "New York, Sep 24 (IANS): Our gut microbiome may have a role to play in our bone health and ward off the risk of osteoporosis and fractures, suggests a study.\r\nThe findings, published in Frontiers in Endocrinology, could one day provide the opportunity to alte…",
        "url": "https://www.daijiworld.com/news/newsDisplay?newsID=1123684",
        "urlToImage": "https://daijiworld.ap-south-1.linodeobjects.com/Linode/images3/rayan_240923_Gut1.jpg",
        "publishedAt": "2023-09-24T09:24:58Z",
        "content": "New York, Sep 24 (IANS): Our gut microbiome may have a role to play in our bone health and ward off the risk of osteoporosis and fractures, suggests a study.\r\nThe findings, published in Frontiers in … [+2196 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "Sharad Pawar's visit to Adani's Gujarat office and home sparks political speculation - Times of India",
        "description": "In an unexpected turn of events, Sharad Pawar's visit to Ahmedabad, Gujarat, has set political circles abuzz. Although the visit was purportedly for personal reasons, it has drawn considerable attention due to the guest of honor and the context. Shar",
        "url": "https://timesofindia.indiatimes.com/videos/toi-original/sharad-pawars-visit-to-adanis-gujarat-office-and-home-sparks-political-speculation/videoshow/103906474.cms",
        "urlToImage": "https://timesofindia.indiatimes.com/photo/msid-103906474,imgsize-1682500.cms",
        "publishedAt": "2023-09-24T09:13:21Z",
        "content": "Sep 24, 2023, 02:43PM ISTSource: TOI.inIn an unexpected turn of events, Sharad Pawar's visit to Ahmedabad, Gujarat, has set political circles abuzz. Although the visit was purportedly for personal re… [+558 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "CNBCTV18"
        },
        "author": "Hormaz Fatakia",
        "title": "Trade Setup for September 25: Nifty 50 may see more volatility in F&O series expiry week - CNBCTV18",
        "description": "Even after last week's correction, the Nifty 50 is up nearly 450 points this series so far. The question is, will the expiry week manage to sustain those gains?",
        "url": "https://www.cnbctv18.com/market/trade-setup-september-25-nifty-50-expiry-week-levels-nifty-bank-today-bajaj-finance-sjvn-hdfc-17868321.htm",
        "urlToImage": "https://images.cnbctv18.com/wp-content/uploads/2023/05/TRADE_SETUP_BG-1019x573.jpg",
        "publishedAt": "2023-09-24T09:05:28Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "HT Entertainment Desk",
        "title": "Pakistani actor Hania Aamir grooves to Chaleya as Shah Rukh dances behind her - Hindustan Times",
        "description": "This isn't the first time that Hania Aamir danced to a song of Shah Rukh Khan. The Pakistani actor earlier shared a video as she did Shah Rukh's signature pose.",
        "url": "https://www.hindustantimes.com/entertainment/tv/pakistani-actor-hania-aamir-dances-to-jawan-song-chaleya-shah-rukh-khan-101695542844723.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/Hania_Aamir_Jawan_Chaleya_Shah_Rukh_Khan_1695545480975_1695545489504.jpg",
        "publishedAt": "2023-09-24T09:00:51Z",
        "content": "Pakistani actor Hania Aamir is a big fan of Shah Rukh Khan and she has proved it time and again by dancing to his songs and giving his signature pose. Taking to Instagram on Saturday, Hania gave her … [+2061 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "ThePrint"
        },
        "author": "Snehesh Alex Philip",
        "title": "For decades, BRO labourers faced a lonely death. Defence Minister Rajnath Singh has now ordered welfare measures - ThePrint",
        "description": "Rajnath Singh approves increase in funeral expenditure & transportation of mortal remains for casually paid labourers killed while working in challenging terrains to build roads in border areas.",
        "url": "https://theprint.in/india/for-decades-bro-labourers-faced-a-lonely-death-defence-minister-rajnath-singh-has-now-ordered-welfare-measures/1775522/",
        "urlToImage": "https://static.theprint.in/wp-content/uploads/2023/09/BRO-min.png",
        "publishedAt": "2023-09-24T08:50:09Z",
        "content": "Stunned by this, Defence Minister Rajnath Singh had directed the BRO to craft appropriate welfare measures.\r\nThe minister has now approved two major changes — the extension of existing provisions of … [+2788 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Ruchi Kaushal",
        "title": "Parineeti Chopra, Raghav Chadha wedding live: Band members gear up for baaraat - Hindustan Times",
        "description": "Parineeti Chopra and Raghav Chadha wedding live updates: Several politicians and celebs reached Udaipur to attend the royal wedding of the year.",
        "url": "https://www.hindustantimes.com/entertainment/bollywood/parineeti-chopra-raghav-chadha-wedding-live-updates-udaipur-pictures-videos-guests-101695526408661.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/parineeti_chopra_raghav_chadha_1695465886983_1695567483660.jpg",
        "publishedAt": "2023-09-24T08:30:37Z",
        "content": "Parineeti Chopra and Raghav Chadha wedding live updates: The actor and the AAP leader are getting married on Sunday. After his sehrabandi, Raghav left with his baaraat from The Taj Lake Palace on boa… [+14139 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Cauvery row: Outfits call for Bengaluru bandh on September 26, transport services to be hit - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/cities/bangalore/cauvery-row-bengaluru-bandh-september-26-transport-services-hit-8953800/",
        "urlToImage": null,
        "publishedAt": "2023-09-24T08:23:50Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Koimoi"
        },
        "author": "Koimoi.com Team",
        "title": "Jawan Box Office (Overseas): Shah Rukh Khan Enters The $40 Million Club Beating Aamir Khan’s Highest Grosser Dangal In North America, Baahubali 2 In Gulf & The Next Target Is RRR! - Koimoi",
        "description": "Shah Rukh Khan's Jawan is still creating records overseas, and the actor achieved another feat. as the film entered the prestigious $40M club",
        "url": "https://www.koimoi.com/box-office/jawan-box-office-overseas-shah-rukh-khan-enters-the-40-million-club-beating-aamir-khans-highest-grosser-dangal-in-north-america-baahubali-2-in-gulf-the-next-target-is-rrr/",
        "urlToImage": "https://static-koimoi.akamaized.net/wp-content/new-galleries/2023/09/jawan-box-office-overseas-shah-rukh-khan-enters-the-40-million-club-beating-aamir-khans-highest-grosser-dangal-in-north-america-baahubali-2-in-gulf-the-next-target-is-rrr.jpg",
        "publishedAt": "2023-09-24T08:00:49Z",
        "content": "Shah Rukh Khan Achieves Another Record In His Book With Jawan Overseas Box Office (Picture Credit: IMDB)\r\nShah Rukh Khan’s Jawan is still working like a charm overseas. The film, which currently stan… [+2223 chars]"
    },
    {
        "source": {
            "id": "bloomberg",
            "name": "Bloomberg"
        },
        "author": "Manolo Serapio Jr",
        "title": "China Installs Barrier in Disputed Sea Shoal, Philippines Says - Bloomberg",
        "description": "China’s Coast Guard installed a floating barrier in the southeast portion of Scarborough Shoal in the South China Sea that’s preventing access for Filipino fishing vessels, according to the Philippines.",
        "url": "https://www.bloomberg.com/news/articles/2023-09-24/china-installs-barrier-in-disputed-sea-shoal-philippines-says",
        "urlToImage": "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iM3JiIJmIBq0/v0/1200x800.jpg",
        "publishedAt": "2023-09-24T07:05:34Z",
        "content": "Chinas Coast Guard installed a floating barrier in the southeast portion of Scarborough Shoal in the South China Sea thats preventing access for Filipino fishing vessels, according to the Philippines… [+333 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Deccan Herald"
        },
        "author": "PTI",
        "title": "World's largest Hindu temple outside India in modern era to be inaugurated in October - Deccan Herald",
        "description": "Robbinsville (New Jersey), Sep 24 (PTI) The world’s largest Hindu temple constructed outside India in the modern era is all set to be inaugurated in New Jersey on October 8.",
        "url": "https://www.deccanherald.com/world/worlds-largest-hindu-temple-outside-india-in-modern-era-to-be-inaugurated-on-october-8-in-new-jersey-2698818",
        "urlToImage": "https://images.deccanherald.com/deccanherald%2F2023-09%2F92d38e65-28ae-4d44-87e4-cf4388f476c2%2FClipboard___2023_09_24T122541_208.jpg?rect=0%2C3%2C1181%2C620&w=1200&ar=40%3A21&auto=format%2Ccompress&ogImage=true&mode=crop",
        "publishedAt": "2023-09-24T06:52:24Z",
        "content": "Our spiritual leader (Pramukh Swami Maharaj) had a vision that in the Western hemisphere there should be a place which can be a place for all people of the world, not only for Hindus, not only for In… [+245 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "Sethu Pradeep",
        "title": "Watch this space: Chandrayaan-3 sleeps as US Space Force punches a hole in atmosphere - The Indian Express",
        "description": "In this week's Watch this Space, Sethu Pradeep writes about how a US Space Force satellite launch may have punched a hole in the atmosphere as ISRO's Chandrayaan-3 mission modules \"slept\" on the Moon.",
        "url": "https://indianexpress.com/article/technology/science/watch-this-space-chandrayaan-3-space-force-8952734/",
        "urlToImage": "https://images.indianexpress.com/2023/09/Watch-this-space-Chandrayaan-3-20230923.jpg",
        "publishedAt": "2023-09-24T06:30:05Z",
        "content": "Despite going long past the end of the missions intended life, the Indian Space Research Organisation (ISRO) stuck out hope for the Chandrayaan-3 mission to be revived after the lunar night. As of no… [+3301 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Sounak Mukhopadhyay",
        "title": "75 years after independence, 40% of Pakistanis live below the poverty line; and its economic model is not working | Mint - Mint",
        "description": "Pakistan's economic model is ineffective in reducing poverty, warns World Bank.",
        "url": "https://www.livemint.com/news/world/75-years-after-independence-40-of-pakistanis-live-below-the-poverty-line-and-its-economic-model-is-not-working-11695528712845.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/Pakistan_1695531495700_1695531495950.jpg",
        "publishedAt": "2023-09-24T05:01:10Z",
        "content": "As Pakistan grapples with an ongoing economic crisis, the World Bank has issued a stark warning: the country's current economic model is no longer effective in reducing poverty. In a recently publish… [+2372 chars]"
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "etimes.in",
        "title": "Kiku Sharda mourns the demise of his parents, writes 'Lost them both within the last 2 months' - Times of India",
        "description": "Comedian Kiku Sharda shared the heartbreaking news of his parents' demise on Instagram. He expressed his emotions and memories with his mother and des",
        "url": "https://timesofindia.indiatimes.com/tv/news/hindi/kiku-sharda-mourns-the-demise-of-his-parents-writes-lost-them-both-within-the-last-2-months/articleshow/103901431.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103901612,width-1070,height-580,imgsize-1353517,resizemode-75,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-24T05:00:00Z",
        "content": "Rupali Ganguly, Kiku Sharda have fun times with Delnaaz Irani at her lavish birthday bash; see picsActress Delnaaz Irani celebrated her birthday with a lavish party, sharing pictures and videos on In… [+196 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "The Hindu",
        "title": "It is still a world of double standards: EAM Jaishankar - The Hindu",
        "description": null,
        "url": "https://www.thehindu.com/news/national/it-is-still-a-world-of-double-standards-eam-jaishankar/article67340629.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T04:48:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "SciTechDaily"
        },
        "author": null,
        "title": "VIR-1388: Clinical Trial of Preventive HIV Vaccine Begins - SciTechDaily",
        "description": "Novel vaccine includes NIH-funded technology in development since 2004. A trial of a preventive HIV vaccine candidate has begun enrollment in the United States and South Africa. The Phase 1 trial will evaluate a novel vaccine known as VIR-1388 for its safety …",
        "url": "https://scitechdaily.com/?p=311063",
        "urlToImage": "https://scitechdaily.com/images/HIV-1-Virus-Particle.jpg",
        "publishedAt": "2023-09-24T04:46:00Z",
        "content": "ByNational Institutes of Health (NIH)September 23, 2023\r\nColorized transmission electron micrograph of an HIV-1 virus particle (yellow/gold) budding from the plasma membrane of an infected H9 T cell … [+6817 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Anirudh Bhattacharyya",
        "title": "India-Canada row: Visa suspension will not affect OCI services, says official - Hindustan Times",
        "description": "India has suspended visa services for Canadian citizens citing security threats to its staff in its consulates in Canada | Latest News India",
        "url": "https://www.hindustantimes.com/india-news/indiacanada-row-visa-suspension-will-not-affect-oci-services-says-official-101695530027980.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/High-Commission-of-Canada-in-New-Delhi--India--Rep_1695530020232.jpg",
        "publishedAt": "2023-09-24T04:33:47Z",
        "content": "India may have suspended visa services for Canadian nationals, applications for issuance of fresh Overseas Citizen of India or OCI have not been impacted.\r\nHigh Commission of Canada in New Delhi, Ind… [+2541 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "GSMArena.com"
        },
        "author": "Peter",
        "title": "Weekly poll results: the iPhone 15 Pro Max is the clear fan favorite, the 15 Plus gets no love - GSMArena.com news - GSMArena.com",
        "description": "The Pro Max has exclusivity on Apple's first periscope lens and that is really making a difference. The upgrade to 48MP for the vanilla phones barely tipped the scales.",
        "url": "https://www.gsmarena.com/weekly_poll_results_the_iphone_15_pro_max_is_the_clear_fan_favorite_the_15_plus_gets_no_love-news-59970.php",
        "urlToImage": "https://fdn.gsmarena.com/imgroot/news/23/09/weekly-poll-results-iphone-15-series/-952x498w6/gsmarena_000.jpg",
        "publishedAt": "2023-09-24T02:11:01Z",
        "content": "Last weeks poll leaves no secrets as to which of the new iPhone 15 models is the most popular sure, its expensive, the periscope camera is an unknown and the older models are still competitive, but t… [+2438 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Tribune India"
        },
        "author": "The Tribune India",
        "title": "Despite dengue, malaria spread, sanitary conditions, health facilities fail to improve - The Tribune India",
        "description": null,
        "url": "https://www.tribuneindia.com/news/ludhiana/despite-dengue-malaria-spread-sanitary-conditions-health-facilities-fail-to-improve-547260",
        "urlToImage": null,
        "publishedAt": "2023-09-24T02:03:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "The Statesman"
        },
        "author": "The Statesman",
        "title": "Breaking norm, dengue spreads to rural Bengal - The Statesman",
        "description": null,
        "url": "https://www.thestatesman.com/bengal/breaking-norm-dengue-spreads-to-rural-bengal-1503225043.html",
        "urlToImage": null,
        "publishedAt": "2023-09-24T01:16:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "India Today"
        },
        "author": "India Today Web Desk",
        "title": "Delhi University elections: ABVP wins 3 seats, NSUI bags vice-president post - India Today",
        "description": "Akhil Bharatiya Vidyarthi Parishad (ABVP) won three out of four major posts in the Delhi University elections while NSUI secured one.",
        "url": "https://www.indiatoday.in/education-today/story/abvp-wins-big-in-delhi-university-elections-bags-3-out-of-4-major-posts-2439609-2023-09-23",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/media_bank/202309/delhi-university-union-231626826-16x9.png?VersionId=3CNHIoCu48XTF4.j2suzkamCaOMqECId",
        "publishedAt": "2023-09-23T12:03:50Z",
        "content": "Akhil Bharatiya Vidyarthi Parishad (ABVP) secured victory in three out of the four central panel posts in the Delhi University Students Union (DUSU) election as the vote counting concluded on Saturda… [+945 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Medical Xpress"
        },
        "author": null,
        "title": "Best news stories 2023-09-23 - Medical Xpress",
        "description": "Daily top 2023-09-23",
        "url": "https://medicalxpress.com/visualstories/2023-09-23-daily-top.amp",
        "urlToImage": null,
        "publishedAt": "2023-09-23T10:32:59Z",
        "content": "Don't miss a beat! Here are yesterday's top stories"
    },
    {
        "source": {
            "id": null,
            "name": "The Indian Express"
        },
        "author": "The Indian Express",
        "title": "Prachanda, the US, and China - The Indian Express",
        "description": null,
        "url": "https://indianexpress.com/article/explained/explained-global/prachanda-the-us-and-china-8952115/",
        "urlToImage": null,
        "publishedAt": "2023-09-23T01:30:12Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Decoding The Impact Of India’s Inclusion Into JPMorgan’s Emerging Market Bond Index | Explained - moneycontrol",
        "description": "India’s much-awaited inclusion into JP Morgan’s emerging market bond index is big news for us. Why’s that? Being included in a new index is like a new stock ...",
        "url": "https://www.youtube.com/watch?v=I8VhoqOWVHo",
        "urlToImage": "https://i.ytimg.com/vi/I8VhoqOWVHo/maxresdefault.jpg",
        "publishedAt": "2023-09-22T15:11:36Z",
        "content": null
    }
]


export default general;